import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/services';
import VendorBanner from '../../components/VendorBanner';
import VendorBanners from '../../components/VendorBanners';
import VendorCampaign from '../../components/VendorCampaign';
import VendorProductList from '../../components/VendorProductList';
import VendorProfile from '../../components/VendorProfile';
import { useGetSelectedTemplate } from '../../services';

type Template3Type = {
  mobileDevice: boolean;
  templateData: [];
  templateId: number;
};

export default function Template3(props: Template3Type) {
  const { mobileDevice, templateData, templateId } = props;
  const { mutateAsync: selectedTemplate } = useGetSelectedTemplate();
  const merhcantTemplateId = useSelector<RootState, number>((state) => state.template.merchantTemplateId);
  const [activeTemplateData, setActiveTemplateData] = useState<any>({});

  useEffect(() => {
    const fetchData = async () => {
      if (merhcantTemplateId > 0) {
        const reponse = await selectedTemplate({
          schema: String(merhcantTemplateId),
        });
        setActiveTemplateData(reponse.template.data);
      }
    };

    fetchData();
  }, [merhcantTemplateId]);

  const mergeData = (templateItems = [], bannerItems = [], widgetItems = []) => {
    const safeTemplate = Array.isArray(templateItems) ? templateItems : [];
    const safeBanner = Array.isArray(bannerItems) ? bannerItems : [];
    const safeWidget = Array.isArray(widgetItems) ? widgetItems : [];

    const bannerMap = safeBanner.reduce((acc: any, item: any) => {
      const key = item?.placeholder;

      if (!acc.has(key)) {
        acc.set(key, []);
      }

      acc.get(key).push(item);

      return acc;
    }, new Map());
    const widgetMap = safeWidget.reduce((acc: any, item: any) => {
      const key = item?.placeholder;

      if (!acc.has(key)) {
        acc.set(key, []);
      }

      acc.get(key).push(item);

      return acc;
    }, new Map());

    const merged = safeTemplate.map((template: any) => {
      const banners = bannerMap.get(template.position?.placeholder);
      const widgets = widgetMap.get(template.position?.placeholder);

      return {
        ...template,
        banners: banners || [],
        widgets: widgets || [],
      };
    });

    const extraBanner = safeBanner.filter((item: any) => !safeTemplate.some((t: any) => t.position?.placeholder === item?.placeholder));
    const extraWidget = safeWidget.filter((item: any) => !safeTemplate.some((t: any) => t.position?.placeholder === item?.placeholder));

    return [...merged, ...extraBanner, ...extraWidget];
  };

  const finalData = mergeData(templateData, activeTemplateData?.banners, activeTemplateData?.widgets);

  const Logo = finalData.find((f: any) => f.position.placeholder === 'mc_vendor_logo');
  const CoverImage = finalData.find((f: any) => f.position.placeholder === 'vendor_lp_position_header');
  const BannerArea1 = finalData.find((f: any) => f.position.placeholder === 'vendor_lp_position_1');
  const BannerArea2 = finalData.find((f: any) => f.position.placeholder === 'vendor_lp_position_2');
  const ProductList1 = finalData.find((f: any) => f.position.placeholder === 'widget_1');
  const BannerArea3 = finalData.find((f: any) => f.position.placeholder === 'vendor_lp_position_6');
  const ProductList2 = finalData.find((f: any) => f.position.placeholder === 'widget_2');
  const BannerArea4 = finalData.find((f: any) => f.position.placeholder === 'vendor_lp_position_7');
  const ProductList3 = finalData.find((f: any) => f.position.placeholder === 'widget_3');
  const BannerArea5 = finalData.find((f: any) => f.position.placeholder === 'vendor_lp_position_8');

  if (!finalData) return null;

  return (
    <>
      <VendorProfile mobileDevice={mobileDevice} logo={Logo} coverImage={CoverImage} templateId={templateId} />
      <VendorBanner mobileDevice={mobileDevice} />
      <VendorCampaign mobileDevice={mobileDevice} />
      <VendorBanners mobileDevice={mobileDevice} bannerData={BannerArea1} templateId={templateId} heightMobile={171} heightWeb={285} />
      <VendorBanners mobileDevice={mobileDevice} bannerData={BannerArea2} templateId={templateId} heightMobile={171} heightWeb={285} />
      <VendorProductList mobileDevice={mobileDevice} productList={ProductList1} templateId={templateId} />
      <VendorBanners mobileDevice={mobileDevice} bannerData={BannerArea3} templateId={templateId} heightMobile={155} heightWeb={334} />
      <VendorProductList mobileDevice={mobileDevice} productList={ProductList2} templateId={templateId} />
      <VendorBanners mobileDevice={mobileDevice} bannerData={BannerArea4} templateId={templateId} heightMobile={80} heightWeb={102} />
      <VendorProductList mobileDevice={mobileDevice} productList={ProductList3} templateId={templateId} />
      <VendorBanners mobileDevice={mobileDevice} bannerData={BannerArea5} templateId={templateId} heightMobile={138} heightWeb={154} />
    </>
  );
}
